export default __webpack_public_path__ + "static/media/016-milk.eabbb672.svg";